<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">
            <div class="question">
                Please enter your <span>pensions accounts</span>.
            </div>
            <div class="answer answer-col">
                <div v-for="(pension, index) in pensions" :key="index">
                    <pension v-model="pensions[index]" @delete="deletePension(pension, index)" />
                    <div class="form-separator">&nbsp;</div>
                </div>

                <div class="add-new">
                    <v-btn fab small @click="addPension(personOne)">
                        <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                    Add another pension
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    import Pension from "@/components/questionnaire/Pension";
    export default {
        name: 'Pensions',
        components: {
            Pension,
            GoBack
        },
        props: [
            'havePensions'
        ],
        mounted() {
            this.$store.dispatch('incomeStreams/loadIncomeStreams');
        },
        methods: {
            next() {
                this.$store.dispatch('incomeStreams/saveIncomeStreams');
                this.$router.push({ name: 'HaveIncome' });
            },
            addPension(person) {
                this.$store.dispatch('incomeStreams/addPension', { person: person });
            },
            deletePension(pension, index) {
                this.$store.dispatch('incomeStreams/deleteIncomeStream', { incomeStream: pension, index: index });
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
                'personTwo',
                'personTwoExists',
            ]),
            ...mapGetters('incomeStreams', [
                'incomeStreams',
                'pensions',
                'newPension',
            ]),
        }
    }
</script>
